import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@node-space/ui-components'
import { RequestErrorCallout } from 'components/Errors/RequestErrorCallout'
import { CustomerDetailsWrapper } from 'pages/Customers/ConfirmCustomer/CustomerDetails'
import { AddCustomerPayload, CustomerEntityType } from 'types/customers'
import { MappedErrorMessageState } from 'types/errors'
import { CompanyCustomerConfirmation } from './CompanyCustomerConfirmation'
import { IndividualCustomerConfirmation } from './IndividualCustomerConfirmation'

type AddCustomerConfirmProps = {
  onContinue: () => void
  isLoading: boolean
  customer: AddCustomerPayload
  onBack: () => void
  requestError: MappedErrorMessageState
  resetRequestError: () => void
}

export const AddCustomerConfirm = ({
  customer,
  onContinue,
  isLoading,
  onBack,
  requestError,
  resetRequestError,
}: AddCustomerConfirmProps) => {
  const { t } = useTranslation()
  const isCompanyCustomer = customer?.customerEntityType === CustomerEntityType.COMPANY

  const handleOnBack = () => {
    resetRequestError()
    onBack()
  }

  return (
    <Box flexCol width={'full'} gapY={20}>
      <CustomerDetailsWrapper>
        {isCompanyCustomer ? (
          <CompanyCustomerConfirmation customer={customer} />
        ) : (
          <IndividualCustomerConfirmation customer={customer} />
        )}
        {requestError?.show && <RequestErrorCallout requestError={requestError} />}
      </CustomerDetailsWrapper>
      <Box flex justify="between">
        <Button variant="secondary" onClick={handleOnBack}>
          {t('back')}
        </Button>
        <Button loading={isLoading} onClick={onContinue}>
          {t('confirm')}
        </Button>
      </Box>
    </Box>
  )
}
